// extracted by mini-css-extract-plugin
export default {"root":"rsPlB6","scrollableContainer":"KjJxdF","optionContainer":"VPYEAp","addToCartButtonContainer":"xczTob"};